/**
 * Shared workspace chrome for OncoAgent product surfaces.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useOaApp } from '../app/OaAppContext';
import { oaAppPath } from '../app/paths';
import '../styles/oa-workspace.css';

const LINKS = [
  { to: oaAppPath('/refer'), label: 'Refer' },
  { to: oaAppPath('/inbox'), label: 'Inbox' },
  { to: oaAppPath('/clinic'), label: 'Clinic' },
  { to: oaAppPath('/pathways'), label: 'Pathways' },
];

export function OaWorkspaceShell({
  children,
  kicker,
  title,
  subtitle,
}: {
  children: React.ReactNode;
  kicker?: string;
  title?: string;
  subtitle?: string;
}): React.ReactElement {
  const loc = useLocation();
  const { embedded } = useOaApp();

  return (
    <div className={`oa-ws${embedded ? ' is-embedded' : ''}`}>
      {embedded ? null : (
        <nav className="oa-ws-nav" aria-label="OncoAgent workspace">
          <Link to="/oncoagent" className="oa-ws-brand">
            ByOnco <em>OncoAgent</em>
          </Link>
          <div className="oa-ws-links">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={loc.pathname.startsWith(l.to) ? 'active' : undefined}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
      <main className="oa-ws-main">
        {kicker ? <div className="oa-ws-kicker">{kicker}</div> : null}
        {title ? <h1 className="oa-ws-title">{title}</h1> : null}
        {subtitle ? <p className="oa-ws-sub">{subtitle}</p> : null}
        {children}
      </main>
    </div>
  );
}

export default OaWorkspaceShell;
